import { FilterChoice } from '../../types/FilterChoice';
import { PathMaker } from '../../types/PathParser';

export const LITERAL_DATE_SHAPE = /^\d{4}-\d{2}-\d{2}$/;

export const makeDateSegment: PathMaker = function* ({ onlineAppointments }: FilterChoice) {
  if (onlineAppointments) {
    if (!onlineAppointments.date) {
      yield 'NextAvailable';
    } else if (typeof onlineAppointments.date === 'string') {
      yield onlineAppointments.date;
    } else {
      yield onlineAppointments.date.start;

      if (onlineAppointments.date.end) {
        yield onlineAppointments.date.end;
      }
    }
  }
};

export const parseDate = (token: string, filters: FilterChoice) => {
  if (LITERAL_DATE_SHAPE.test(token)) {
    /** Literal date ranges may consist of only a start-date, or a start-date AND end-date.
     * Because we could run out of tokens before reading an end-date, we need to set the date
     * property on the filters BEFORE we attempt to read an end-date.
     */
    const date = filters.onlineAppointments?.date;

    if (typeof date === 'object') {
      filters.onlineAppointments = {
        ...filters.onlineAppointments,
        date: { ...date, end: token },
      };
    } else {
      filters.onlineAppointments = { ...filters.onlineAppointments, date: { start: token } };
    }

    return true;
  }

  return false;
};
